import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/static/icons/trash_icon.svg'


const _hoisted_1 = { class: "installer-form" }
const _hoisted_2 = { class: "installer-form__form_data" }
const _hoisted_3 = { class: "installer-form__contact-information" }
const _hoisted_4 = { class: "installer-form__contact-information-heading" }
const _hoisted_5 = { class: "installer-form__field-group" }
const _hoisted_6 = {
  class: "installer-form__label",
  for: "installerPhone"
}
const _hoisted_7 = { class: "installer-form__field-group" }
const _hoisted_8 = { class: "installer-form__field-group" }
const _hoisted_9 = {
  key: 0,
  class: "installer-form__field-group"
}
const _hoisted_10 = { class: "installer-form__counties-label" }
const _hoisted_11 = { class: "installer-form__counties-wrap" }
const _hoisted_12 = { class: "installer-form__counties-container" }
const _hoisted_13 = {
  key: 0,
  class: "installer-form__dropdown-wrap"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("line", { class: "installer-form__separator" }, null, -1)
const _hoisted_16 = { class: "installer-form__succes-save-state" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "trash-icon"
}, null, -1)
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "installer-form__remove-installer-text" }
const _hoisted_20 = ["disabled"]

import { computed, ref } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useInstaller from '@/composables/useInstaller';
import useContext from '@/composables/useContext';

import parsePhoneNumberFromString from 'libphonenumber-js';
import { validateEmail, validateUrl } from '@/helpers/utils';

import PhoneInput from '@/components/forms/PhoneInput.vue';
import Dropdown from '@/components/forms/Dropdown.vue';
import TextInput from '@/components/forms/TextInput.vue';
import ErrorMessage from '@/components/forms/ErrorMessage.vue';
import WebsiteInput from '@/components/forms/WebsiteInput.vue';
import InstallerRemove from './InstallerRemove.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallerForm',
  emits: ['add', 'edit', 'remove'],
  setup(__props, { emit }) {

const { mitt } = useContext();
const { websiteText } = useWebsiteTexts();
const {
  requestPending,
  installerData,
  counties,
  hasInstallerData,
  phoneCountry,
  canEditCounties,
  updatePhoneNumber,
  updateWebsite,
  addOrUpdateInstaller,
  removeInstaller,
  getCountiesText,
} = useInstaller();



const error = ref('');

const requiredFieldError = computed(() => {
  return websiteText('global__forms__requiredfielderror').value;
});

function validateInstallerInfo() {
  let isValid = true;

  if (!installerData.value.email) {
    installerData.value.emailError = websiteText(
      'global__required_field'
    ).value;
    isValid = false;
  } else if (!validateEmail(installerData.value.email)) {
    installerData.value.emailError = websiteText('global__email_invalid').value;
    isValid = false;
  }

  const parsedNumber = parsePhoneNumberFromString(
    installerData.value.phone,
    phoneCountry.value
  );
  if (!parsedNumber || !parsedNumber.isValid()) {
    installerData.value.phoneError = websiteText('global__invalid_phone').value;
    isValid = false;
  }
  if (
    installerData.value.website &&
    !validateUrl(installerData.value.website)
  ) {
    installerData.value.websiteError = websiteText('global__invalid_url').value;
    isValid = false;
  }

  if (installerData.value.counties.length === 0) {
    installerData.value.countiesError = websiteText(
      'global__required_field'
    ).value;
    isValid = false;
  }

  return isValid;
}

function resetPhoneError() {
  installerData.value.phoneError = '';
  resetEmailError();
}

function resetEmailError() {
  installerData.value.emailError = '';
  resetWebsiteError();
}
function resetWebsiteError() {
  installerData.value.websiteError = '';
  resetCountyError();
}
function resetCountyError() {
  installerData.value.countiesError = '';
}

function phoneNumberChanged() {
  if (hasInstallerData.value) {
    const [_prefix, sufix] = installerData.value.phone.split(/\s+/);
    if (!sufix) {
      installerData.value.phoneError = requiredFieldError.value;
      return;
    }
    const parsedNumber = parsePhoneNumberFromString(
      installerData.value.phone,
      phoneCountry.value
    );
    if (!parsedNumber || !parsedNumber.isValid()) {
      installerData.value.phoneError = websiteText(
        'global__invalid_phone'
      ).value;
      return;
    }
  } else if (!installerData.value.phone) {
    installerData.value.phoneError = requiredFieldError.value;
  } else {
    installerData.value.phoneError = '';
  }
}

function emailAddressChanged() {
  if (!installerData.value.email) {
    installerData.value.emailError = requiredFieldError.value;
  } else if (!validateEmail(installerData.value.email)) {
    installerData.value.emailError = websiteText('global__email_invalid').value;
    return;
  } else {
    installerData.value.emailError = '';
  }
}
function websiteChanged() {
  if (
    installerData.value.website === 'https://' ||
    installerData.value.website === 'http://'
  ) {
    installerData.value.website = '';
    return;
  }
  if (installerData.value.website) {
    if (!validateUrl(installerData.value.website))
      installerData.value.websiteError = websiteText(
        'global__invalid_url'
      ).value;
  } else {
    installerData.value.websiteError = '';
  }
}

function countiesChanged() {
  if (installerData.value.counties.length < 1)
    installerData.value.countiesError = requiredFieldError.value;
  else {
    installerData.value.countiesError = '';
  }
}

async function addOrUpdate() {
  try {
    if (!validateInstallerInfo()) {
      return;
    }
    error.value = '';

    await addOrUpdateInstaller();
    emit(!hasInstallerData.value ? 'add' : 'edit');
  } catch (err: any) {
    error.value = err;
  }
}

function openInstallerDataRemoveModal() {
  mitt.emit('Remove:InstallerData:Open');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('mypages__installer_contact_info').value), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(websiteText)('global__phone').value), 1),
          _createVNode(PhoneInput, {
            id: "installerPhone",
            class: "installer-form__phone-input",
            value: _unref(installerData).phone,
            "selected-country": _unref(phoneCountry),
            placeholder: _unref(websiteText)('global__phone').value,
            "error-message": _unref(installerData).phoneError,
            onInput: _unref(updatePhoneNumber),
            onFocus: resetPhoneError,
            onBlur: phoneNumberChanged
          }, null, 8, ["value", "selected-country", "placeholder", "error-message", "onInput"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            modelValue: _unref(installerData).email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(installerData).email) = $event)),
            id: "installerEmail",
            autocomplete: "email",
            label: _unref(websiteText)('mypages__installer_email').value,
            "error-message": _unref(installerData).emailError,
            onEnterKeyPressed: addOrUpdate,
            onFocus: resetEmailError,
            onBlur: emailAddressChanged
          }, null, 8, ["modelValue", "label", "error-message"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(WebsiteInput, {
            id: "installerWebsite",
            label: _unref(websiteText)('mypages__installer_website').value,
            value: _unref(installerData).website,
            "error-message": _unref(installerData).websiteError,
            onInput: _unref(updateWebsite),
            onFocus: resetWebsiteError,
            onBlur: websiteChanged
          }, null, 8, ["label", "value", "error-message", "onInput"])
        ]),
        (_unref(hasInstallerData) && !_unref(canEditCounties))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(websiteText)('installer_form__counties_label').value), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getCountiesText)(), (county, index) => {
                    return (_openBlock(), _createElementBlock("p", { key: county }, _toDisplayString(county + (index < _unref(getCountiesText)().length - 1 ? ',' : '')), 1))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  class: "clean-button installer-form__edit-counties",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (canEditCounties.value = true))
                }, _toDisplayString(_unref(websiteText)('installer_form__show_county_dropdown').value), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(canEditCounties))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(Dropdown, {
              id: "installerCounties",
              label: _unref(websiteText)('mypages__installer_lans_label').value,
              placeholder: 
            _unref(websiteText)('mypages__installer_lans_placeholder').value
          ,
              "search-placeholder": 
            _unref(websiteText)('installer_form__search_placeholder').value
          ,
              options: _unref(counties),
              "multiple-select": true,
              "enable-search": true,
              "model-values": _unref(installerData).counties,
              "onUpdate:model-values": _cache[2] || (_cache[2] = ($event: any) => ((_unref(installerData).counties) = $event)),
              "error-message": _unref(installerData).countiesError,
              onFocus: resetCountyError,
              onBlur: countiesChanged
            }, {
              "selected-more": _withCtx((slotOptions) => [
                _createTextVNode(_toDisplayString(slotOptions.moreSelected > 1
                ? '+ ' +
                  _unref(websiteText)('dropdown__multi_select_more', {
                    count: slotOptions.moreSelected - 1,
                  }).value
                : ''), 1)
              ]),
              _: 1
            }, 8, ["label", "placeholder", "search-placeholder", "options", "model-values", "error-message"])
          ]))
        : _createCommentVNode("", true),
      (_unref(hasInstallerData))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (openInstallerDataRemoveModal())),
                class: "clean-button installer-form__remove-installer",
                disabled: _unref(requestPending)
              }, _toDisplayString(_unref(websiteText)('mypages__installer__remove_installer').value), 9, _hoisted_18)
            ]),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(websiteText)('mypages__installer__remove_disclaimer').value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        { 'installer-form__actions': !_unref(hasInstallerData) },
        { 'installer-form__actions-save': _unref(hasInstallerData) },
      ])
    }, [
      _createElementVNode("button", {
        class: _normalizeClass([
          'installer-form__submit',
          { 'button-primary': !_unref(hasInstallerData) },
          { 'button-secondary': _unref(hasInstallerData) },
        ]),
        onClick: addOrUpdate,
        disabled: _unref(requestPending)
      }, _toDisplayString(_unref(hasInstallerData)
            ? _unref(websiteText)('global__save').value
            : _unref(websiteText)('mypages__installer__become_installer').value), 11, _hoisted_20),
      (_unref(installerData).submitError)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            message: _unref(installerData).submitError
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(InstallerRemove, {
      onRemove: _cache[4] || (_cache[4] = ($event: any) => (emit('remove')))
    })
  ]))
}
}

})